var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[_c('div',{staticClass:"empty-state-content"},[_c('img',{staticClass:"empty-state-image",attrs:{"src":require("../../../assets/table-loading.png"),"alt":"Loading"}}),_c('p',{staticClass:"empty-state-text"},[_vm._v("No application data available")])])])
}]

export { render, staticRenderFns }